









import { format, eachMonthOfInterval, isSameDay  } from 'date-fns'
import { Vue } from "@/app"
import { use } from "echarts/core"
import { CanvasRenderer } from "echarts/renderers"
import { LineChart } from "echarts/charts"
import {
  GridComponent,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components"
import VChart from "vue-echarts"
import { LineSeriesOption } from "echarts/charts"
import { DataZoomComponent } from 'echarts/components'
import { ToolboxComponent } from 'echarts/components'

use([
  CanvasRenderer,
  LineChart,
  GridComponent,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomComponent,
  ToolboxComponent,
])

interface MonthlyExpectedReturn {
  type: string;
  total: number;
  month: string;
}

function moneyFormatter(amount) {
  if (amount == null || amount == undefined) {
    return ''
  }
  let val
  if (typeof(amount) == 'object') {
    val = Number.parseFloat(amount.value).toFixed(Math.round(amount.value) == amount.value ? 0 : 2)
  } else {
    val = Number.parseFloat(amount).toFixed(Math.round(amount) == amount ? 0 : 2)
  }
  const formatted = val.toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ') // add thousands separator
  return formatted + (typeof(amount) == 'number' ? ' €' : '')
}

export default Vue.extend({
  name: "ExpectedReturns",
  components: {
    VChart,
  },
  data() {
    return {
      loading: true,
      animating: true,
      isFullscreen: false,
      option: {
        color: ["#000", "#81847d", "#605c64", "#a29a9d"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
              formatter: (params) => {
                if (params.axisDimension == 'x') {
                  return format(new Date(params.value), "dd.MM.yyyy")
                } else if (params.axisDimension == 'y') {
                  return moneyFormatter(params.value)
                }
              },
            },
          },
        },
        toolbox: {
          feature: {
            myFullscreen: {
              title: 'Fullscreen',
              icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcAQMAAABIw03XAAAACXBIWXMAAC4jAAAuIwF4pT92AAAABlBMVEVHcEwAAACfKoRRAAAAAXRSTlMAQObYZgAAABtJREFUCNdj+H/A/gMDGvGBgQEPQSzAbwoWewGTmC3x+miLrAAAAABJRU5ErkJggg==',
              onclick: () => {
                // Yes, `isFullscreen` does not exist when `data` is initialized,
                // but it is present at the moment of execution

                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                this.isFullscreen ? document.exitFullscreen() : this.$refs.card.$el.requestFullscreen()
              },
            },
          },
        },
        grid: {
          left: "3%",
          right: "10%",
          bottom: "20%",
          containLabel: true,
        },
        legend: {
          data: [ this.$t("dashboardPage.principal"), this.$t("dashboardPage.interest") ],
        },
        xAxis: [{
          type: "category",
          boundaryGap: false,
          data: [],
          axisLabel: {
            formatter: (label: string) => {
              return format(new Date(label), "MMM")
            },
          },
        }],
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: moneyFormatter,
          },
        },
        dataZoom: [
          {
            type: 'inside',
            startValue: 0, // index of element
            endValue: 5, // index of element
          },
          {
            top: '82%',
            height: 45, // default is 30 - too small for me
            brushStyel: {},
            labelFormatter: function(value, valueStr) {
              // Something-something, valueStr results in an "incorrect data format" when testing via cypress
              // Playwright tests are fine. Port tests faster!
              return format(new Date(valueStr || 0), "dd.MM.yyyy")
            },
          },

        ],
        series: [] as LineSeriesOption[],
      },
    }
  },
  computed: {
    accountId: function() {
      return this.$store.state.account.id
    },
  },
  watch: {
    accountId: {
      immediate: true,
      handler() {
        this.getExpectedReturns()
      },
    },
  },
  methods: {
    getExpectedReturns() {
      if (this.accountId) {
        this.loading = true
        this.animating = true
        this.$http
          .get(`/dashboard/${this.accountId}/returns/`)
          .then((response: { data: { [key: string]: MonthlyExpectedReturn[] } }) => {
            this.loading = false
            const xAxis = []
            this.option.series = []
            this.option.xAxis[0].data = []
            let values = response.data
            const lastItem = [...response.data.principal].pop()
            const lastMonth = lastItem.month
            const returnsPeriod = eachMonthOfInterval({
              start: new Date(response.data.principal[0].month),
              end: new Date(lastMonth),
            })
            for (const type of Object.keys(values)) {
              const data: LineSeriesOption = {
                name: this.$t(`dashboardPage.${type}`),
                type: "line",
                stack: type,
                lineStyle: {
                  width: 4,
                },
                label: {
                  show: true,
                  position: "top",
                  formatter: moneyFormatter,
                },
                emphasis: {
                  focus: "series",
                },
                labelLayout: {
                  hideOverlap: true,
                },
                data: [],
                tooltip: {
                  valueFormatter: moneyFormatter,
                },
              }
              for (const month of returnsPeriod) {
                let totalThisMonth = 0
                totalThisMonth = response.data[type]
                  .find(ret => isSameDay(new Date(ret.month), month))?.total || 0
                data.data.push(totalThisMonth)
                xAxis.push(format(new Date(month), "yyyy-MM-dd"))
              }
              this.option.series.push(data)
            }
            // XXX: Looks wrong, but it works. Maybe needs a rework in the future
            this.option.xAxis[0].data = xAxis.slice(0, returnsPeriod.length)
            this.option.dataZoom[0].endValue = Math.min(5, returnsPeriod.length)
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
  },
})
